module.exports = __webpack_public_path__ + "static/media/cancel_waitlist_participation.73c25212.png";